module.exports = __webpack_public_path__ + "img/dcu30-2.124379c1.png";